export default "__VITE_ASSET__DGI0ZwqJ__"